import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Empregador } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ModalPesquisaEmpregadorComponent } from './modal-pesquisa-empregador.component';
import { PainelDadosEmpregadorComponent } from './painel-dados-empregador.component';
import { PainelSecretariosEmpregadorComponent } from './painel-secretarios-empregador.component';
import { SeletorEmpregadorExistenteComponent } from './seletor-empregador-existente.component';
import { ServicoEmpregadorAdministrativo } from './servico-empregador-administrativo';
import { ServicoPortalServidor } from '../servidor/servico-portal-servidor';

@Component({
  selector: 'app-tela-empregador',
  standalone: true,
  imports: [
    CommonModule,
    ModalPesquisaEmpregadorComponent,
    PainelDadosEmpregadorComponent,
    PainelSecretariosEmpregadorComponent,
    RodapeCrudComponent,
    SeletorEmpregadorExistenteComponent
  ],
  templateUrl: './tela-empregador.component.html'
})
export class TelaEmpregadorComponent {
  @Input({ required: true }) empregador!: Empregador;
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() urlTerminal = '';

  @Output() selecionar = new EventEmitter<unknown>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() limpar = new EventEmitter<Empregador>();
  @Output() salvar = new EventEmitter<Empregador>();
  @Output() excluir = new EventEmitter<void>();

  buscaEmpregador = '';
  buscaEmpregadorModal = '';
  modalEmpregadoresAberta = false;

  constructor(
    private readonly servicoBuscaCadastro: ServicoBuscaCadastro,
    private readonly servicoEmpregadorAdministrativo: ServicoEmpregadorAdministrativo,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoPortalServidor: ServicoPortalServidor
  ) {}

  get empregadoresFiltrados() {
    return this.servicoBuscaCadastro.filtrarEmpregadores(
      this.empregadores,
      this.buscaEmpregador,
      this.empregadorSelecionado
    );
  }

  get empregadoresModal() {
    return this.servicoBuscaCadastro.listarEmpregadoresModal(this.empregadores, this.buscaEmpregadorModal);
  }

  rotuloEmpregador = (item: unknown) => this.servicoBuscaCadastro.rotuloEmpregador(item);

  detalheEmpregador = (item: unknown) => this.servicoBuscaCadastro.detalheEmpregador(item);

  alterarBusca(valor: string) {
    this.buscaEmpregador = valor;
    if (!this.buscaEmpregador.trim()) {
      this.limparEmpregador();
      return;
    }
    if (this.buscaEmpregador.trim().length < 3) {
      return;
    }

    const unico = this.empregadoresFiltrados[0];
    if (this.empregadoresFiltrados.length === 1 && unico.id === this.empregadorSelecionado) {
      this.selecionarEmpregador(unico, false);
    }
  }

  abrirModalEmpregadores() {
    this.buscaEmpregadorModal = '';
    this.modalEmpregadoresAberta = true;
  }

  fecharModalEmpregadores() {
    this.modalEmpregadoresAberta = false;
  }

  limparBuscaEmpregadorModal() {
    this.buscaEmpregadorModal = '';
  }

  selecionarEmpregador(item: unknown, fecharModal = true) {
    this.selecionar.emit(item);
    if (fecharModal) {
      this.fecharModalEmpregadores();
    }
  }

  alterarTenant(valor: string) {
    this.empregador = this.servicoEmpregadorAdministrativo.comTenant(this.empregador, valor);
  }

  async carregarLogo(event: Event) {
    const input = event.target as HTMLInputElement;
    const arquivo = input.files?.[0];
    if (!arquivo) {
      return;
    }

    try {
      const logo = await this.servicoEmpregadorAdministrativo.carregarLogoArquivo(arquivo);
      this.empregador = this.servicoEmpregadorAdministrativo.comLogo(this.empregador, logo);
    } catch (erro) {
      this.mensagem.emit(erro instanceof Error ? erro.message : this.servicoEmpregadorAdministrativo.mensagemErroCarregarLogo());
      input.value = '';
    }
  }

  removerLogo() {
    this.empregador = this.servicoEmpregadorAdministrativo.semLogo(this.empregador);
  }

  limparEmpregador() {
    this.buscaEmpregador = '';
    this.buscaEmpregadorModal = '';
    this.empregador = this.servicoEmpregadorAdministrativo.novoEmpregador();
    this.limpar.emit(this.empregador);
  }

  gerarAcessosPortal() {
    if (!this.empregador.id) {
      this.mensagem.emit('Salve o empregador antes de gerar os acessos.');
      return;
    }
    if (!window.confirm('Gerar acessos do portal para os servidores ativos? Login = CPF. Senha inicial = 6 primeiros digitos do CPF, ou a senha portal informada no cadastro do funcionario.')) {
      return;
    }
    this.servicoEmpregadorAdministrativo.gerarAcessos(this.empregador.id).subscribe({
      next: resultado => this.mensagem.emit(this.servicoPortalServidor.mensagemAcessos(resultado)),
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao gerar acessos do portal.'))
    });
  }

  salvarEmpregador() {
    const editando = !!this.empregador.id;
    this.servicoEmpregadorAdministrativo.salvar(this.empregador).subscribe({
      next: salvo => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(editando));
        this.empregador = this.servicoEmpregadorAdministrativo.prepararCadastro(salvo);
        this.salvar.emit(salvo);
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, this.servicoEmpregadorAdministrativo.mensagemErroSalvar()))
    });
  }

  excluirEmpregador() {
    if (!this.empregador.id || !window.confirm(this.servicoEmpregadorAdministrativo.mensagemConfirmarExclusao())) {
      return;
    }

    this.servicoEmpregadorAdministrativo.excluir(this.empregador.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroExcluido());
        this.limparEmpregador();
        this.excluir.emit();
      },
      error: () => this.mensagem.emit(this.servicoEmpregadorAdministrativo.mensagemErroExcluir())
    });
  }

}
